export default {
  primaryColor: '#FF5A41',
  primaryActiveColor: '#E54830',
  iconBackgroundColor: 'rgba(255, 90, 65, 0.1)',
  socialIconBackgroundColor: 'rgba(115, 116, 143, 0.1)',
  textColor: '#212128',
  secondaryTextColor: '#73748F',
  lightTextColor: '#FFE9E6',
  lightSecondaryTextColor: '#FFC5BC',
  disabledTextColor: '#C8C8D8',
  linkColor: 'rgba(111, 88, 255, 1)',
  backgroundColor: '#ffffff',
  sectionBackgroundColor: '#FBF3F3',
  invertedBackgroundColor: '#221D1C',
  dividerColor: '#DDDDEB',
  tagsColor: '#FFF',
  tagsColorActive: '#2f2f3e',
  graphColor: '#F5F5F7',
  graphVividColor: '#FFA395',
  prevPriceColor: '#B1B1BA',
  inputBorderColor: '#C8C8D8',
  mainFont: 'Old Standard TT',
  defaultFont: 'Mulish',
  buttonColor: '#FFE9E6',
  buttonSecondaryColor: '#FFC5BC',  
};
